import React, { useState} from 'react';
import Alert from './Alert';
function RegisterAsset(props) {
    const [asset, setAsset] = useState({
        _assetId:"",
        _manufacturingYear:"",
        _assetManufacturer:"",
        _assetGrade:"",
        _assetName:"",
        _assetCondition:"",
        _cardNumber:"",
        _set:"",
        _assetDetails:""
      });
      const[valid,setValid]=useState(0);
      let name,value;
      const handleInputs=(e)=>{
          name=e.target.name;
          value=e.target.value;
          setAsset({...asset,[name]:value});
      }
      const isNum=(e)=>{
          value=e.target.value;
          if(isNaN(value)){
              setValid(1);
          }
          else{
              setValid(0);
          }
      }
      const registering=async (e) => {
        props.setProgress(10);
        e.preventDefault(); 
        try{
            const accounts = await window.ethereum.enable();
            const account = accounts[0];
            // const gas = await SimpleContract.methods.registerNewAsset(asset._assetId,asset._manufacturingYear,asset._assetManufacturer,asset._assetGrade,asset._assetName,asset._assetCondition,asset._cardNumber,asset._set).estimateGas();
            let{_assetId,_manufacturingYear,_assetManufacturer,_assetGrade,_assetName,_assetCondition,_cardNumber,_set,_assetDetails}=asset;
            // console.log(_assetDetails);
            if(isNaN(_assetGrade)){
                setValid(1);
                return;
            }
            _assetGrade=parseInt(parseFloat(_assetGrade)*10);
            console.log(_assetGrade);
            
            props.setProgress(100);
            setAsset({
                _assetId:"",
                _manufacturingYear:"",
                _assetManufacturer:"",
                _assetGrade:"",
                _assetName:"",
                _assetCondition:"",
                _cardNumber:"",
                _set:"",
                _assetDetails:""
            });
            const result = await props.SimpleContract.methods.registerNewAsset(_assetId,_manufacturingYear,_assetManufacturer,_assetGrade,_assetName,_assetCondition,_cardNumber,_set,_assetDetails).send({
                from: account
            })
        }
        catch(err){
            console.log(err);
        }
    }
    const isMetaMaskInstall=()=>{
        if(props.SimpleContract===undefined){
            const  obj={
                type:"warning",
                message:"Please Install MetaMask and Refresh the Page and only egs is authorized to register asset."
            }
            return(
                <Alert alert={obj}/>
            )
        }
        else{
            const  obj={
                type:"warning",
                message:"Only egs is authorized to register asset."
            }
            return(
                <Alert alert={obj}/>
            )
        }
    }
    return (
        <>
        {isMetaMaskInstall()}
        <div className="forcenter">
        <div className="forregister">
          <form className="container">
            <div className="form-floating mb-3">
                <input type="text" className="form-control" id="_assetId" name="_assetId" value={asset._assetId}  placeholder="assetId" onChange={handleInputs}/>
                <label htmlFor="floatingInput">Asset Id</label>
            </div>
            <div className="form-floating mb-3">
                <input type="text" className="form-control" id="_manufacturingYear" name="_manufacturingYear" value={asset._manufacturingYear}   placeholder="manufacturingYear" onChange={handleInputs}/>
                <label htmlFor="floatingInput">Manufacturing Year</label>
            </div>
            <div className="form-floating mb-3">
                <input type="text" className="form-control" id="_assetManufacturer" name="_assetManufacturer" value={asset._assetManufacturer}   placeholder="assetManufacturer" onChange={handleInputs}/>
                <label htmlFor="floatingInput">Asset Manufacturer</label>
            </div>
            <div className="form-floating mb-3">
                <input type="text" className={(valid===0?"form-control":"form-control is-invalid")} id="_assetGrade" name="_assetGrade" value={asset._assetGrade}  placeholder="assetGrade" onChange={(e)=>{handleInputs(e);isNum(e);}}/>
                <label htmlFor="floatingInput">Asset Grade</label>
            </div>
            <div className="form-floating mb-3">
                <input type="text" className="form-control" id="_assetName" name="_assetName" value={asset._assetName}   placeholder="assetName" onChange={handleInputs}/>
                <label htmlFor="floatingInput">Asset Name</label>
            </div>
            <div className="form-floating mb-3">
                <input type="text" className="form-control" id="_assetCondition" name="_assetCondition" value={asset._assetCondition}   placeholder="assetCondition" onChange={handleInputs}/>
                <label htmlFor="floatingInput">Asset Condition</label>
            </div>
            <div className="form-floating mb-3">
                <input type="text" className="form-control" id="_cardNumber" name="_cardNumber" value={asset._cardNumber}  placeholder="cardNumber" onChange={handleInputs}/>
                <label htmlFor="floatingInput">Card Number</label>
            </div>
            <div className="form-floating mb-4">
                <input type="text" className="form-control" id="_set" name="_set" value={asset._set}  placeholder="set" onChange={handleInputs}/>
                <label htmlFor="floatingInput">Set</label>
            </div>
            <div className="form-floating mb-4">
                <input type="text" className="form-control" id="_assetDetails" name="_assetDetails" value={asset._assetDetails}  placeholder="set" onChange={handleInputs}/>
                <label htmlFor="floatingInput">Asset Details</label>
            </div>
            <button type="submit" className="btn btn-primary" disabled={!(asset._assetId!=="" && asset._assetCondition!=="" && asset._assetGrade!==""
            && asset._assetManufacturer!=="" && asset._assetName!=="" && asset._cardNumber!=="" && asset._manufacturingYear!=="" && asset._set!=="" && asset._assetDetails!=="")} onClick={registering}>Submit</button>
        </form> 
        </div>
        </div>
        </>
    )
}

export default RegisterAsset
